import * as getters from './getters.js';
import * as mutations from './mutations.js';
import * as actions from './actions.js';

const state = {
    model: 'devices',
    items: [],

    constants: {
        types: {
            1: {
                id: 1,
                label: "4G Device",
                colors: {
                    bg: "bg-cyan-100",
                    text: "text-black",
                },
            },
            2: {
                id: 2,
                label: "5G Device",
                colors: {
                  bg: "bg-cyan-100",
                  text: "text-black",
                },
            }
        },
        plan_types: {
            'day': {
                id: 'day',
                label: "Day",
                colors: {
                    bg: "bg-cyan-100",
                    text: "text-black",
                },
            },
            'month': {
                id: 'month',
                label: "Month",
                colors: {
                  bg: "bg-cyan-100",
                  text: "text-black",
                },
            }
        },
    },

    pagination: {
        limit: 25,
    },

    loading: false,

    viewIndexData: {
        pageTitle: 'Devices',
        tableHeads: [
            {title: 'Name', key: 'name'},
            {title: 'Device type', key: 'type', type: "badge", constant: "types"},
            {title: 'Plan type', key: 'plan_type', type: "badge", constant: "plan_types"},
            {title: 'Extra charge $', key: 'extra_charge'},
        ],
        tableProps: {
            create: true,
            show: true,
            destroy: true,
            edit: true,
            group: false,
            search: true,
            itemsLimit: true,
            upload: false,
        }
    },

    viewCreateData: {
        pageTitle: 'Create device',
    },

    viewDetailData: {
        pageTitle: 'Device details',
        fields: [
            {text: 'Name', key: 'name'},
            {text: 'Note', key: 'note'},
            {text: 'Plan type', key: 'plan_type'},
            {text: 'Extra charge $', key: 'extra_charge'},
            {text: 'Device type', key: 'type', type: "badge", constant: "types",},
        ],
    },

    viewEditData: {
        pageTitle: 'Edit Device',
    },
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};